const e=(e,t)=>e.delete(`/orgs/${t}`);export{e as deleteOrg};
//# sourceMappingURL=delete-org.mjs.map